import { xApp } from 'xumm-xapp-sdk'

let sdk: xApp | null = null
let isXappContext = false
let initialized = false

/**
 * Initialize storage system - call this on app startup
 */
export async function initStorage(): Promise<void> {
  if (initialized) return
  
  try {
    sdk = new xApp()
    const env = sdk.getEnvironment()
    isXappContext = !!env.ott
    
    if (isXappContext) {
      console.log('[Storage] Running in Xaman xApp context - using userstore')
    } else {
      console.log('[Storage] Running in browser - using localStorage')
    }
  } catch (error) {
    console.warn('[Storage] Failed to initialize xApp SDK, falling back to localStorage:', error)
    isXappContext = false
  }
  
  initialized = true
}

/**
 * Get item from storage (async for userstore compatibility)
 */
export async function getStorageItem(key: string): Promise<string | null> {
  if (!initialized) {
    await initStorage()
  }
  
  if (isXappContext && sdk) {
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const value = await (sdk as any).storage.get(key)
      return value || null
    } catch (error) {
      console.error('[Storage] Error reading from userstore:', error)
      return null
    }
  }
  
  return localStorage.getItem(key)
}

/**
 * Set item in storage (async for userstore compatibility)
 */
export async function setStorageItem(key: string, value: string): Promise<void> {
  if (!initialized) {
    await initStorage()
  }
  
  if (isXappContext && sdk) {
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      await (sdk as any).storage.set(key, value)
    } catch (error) {
      console.error('[Storage] Error writing to userstore:', error)
      throw error
    }
  } else {
    localStorage.setItem(key, value)
  }
}

/**
 * Remove item from storage (async for userstore compatibility)
 */
export async function removeStorageItem(key: string): Promise<void> {
  if (!initialized) {
    await initStorage()
  }
  
  if (isXappContext && sdk) {
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      await (sdk as any).storage.delete(key)
    } catch (error) {
      console.error('[Storage] Error deleting from userstore:', error)
      throw error
    }
  } else {
    localStorage.removeItem(key)
  }
}

/**
 * Check if running in Xaman xApp context
 */
export function isXamanContext(): boolean {
  return isXappContext
}
